module.exports = __webpack_public_path__ + "img/assessment.ff5c2c9b.svg";